import React, {useState} from 'react';
import { useTransactions } from '../../../Data/Payments';
import CustomerPicker from '../../../Components/CustomerPicker';
import Search, { SearchBar, useSearch } from '../../../Components/Search';
import ListView from './ListView';
import TransactionSearch from './TransactionSearch';
import { usePreference } from '../../../Data/Preference';
import { useDialogues } from '../../../Components/Dialogues';

const Transactions = () => {
    const [searchData, setSearchData] = usePreference('transactionSearch', {direction: 'Credit', statuses: ['New', 'Matched']});

    return <Search data={searchData} onChange={setSearchData}>
        <Inner />
    </Search>
}

const Inner = () => {
    const {confirm} = useDialogues();
    const {searchDebounced, hasSearchConditions, searchData, setSearchData, liveSearch} = useSearch();
    const {isLoading, transactions, isEmpty, resetTransaction, ignoreTransaction, convertTransactionForCustomer, ignoreAllNew, confirmAllMatched} = useTransactions(searchDebounced, true);
    const [matchingTransaction, setMatchingTransaction] = useState(false);
    const [pickerPrompt, setPickerPrompt] = useState(false);
    const [actioningTransaction, setActioningTransaction] = useState(null);

    const matchCustomer = (transaction) => {
        setMatchingTransaction(transaction);
        setPickerPrompt(transaction.debtorName ?? transaction.description);
    }

    const actionTransaction = async (transaction, action) => {
        setActioningTransaction(transaction.transactionId);
        try {
            await action(transaction);
        } catch (err) {
            console.log(err);
        }
        setActioningTransaction(null);
    }

    return <>
        <SearchBar
            filterForm={<TransactionSearch {...{searchData, setSearchData}} />}
            isLoading={isLoading}
            modalOptions={{
                title: 'Search transactions',
                theme: 'primary',
                icon: 'MagnifyingGlass',
            }}
            sideMenu={[
                {
                    title: 'Ignore all new',
                    icon: 'EyeSlash',
                    onClick: () => confirm(
                        {
                            title: 'Ignore all new',
                            message: 'Mark all new transactions as ignored?',
                            theme: 'primary',
                        },
                        () => ignoreAllNew()
                    )
                },
                {
                    title: 'Confirm all matches',
                    icon: 'UserCheck',
                    onClick: () => confirm(
                        {
                            title: 'Confirm all matches',
                            message: 'Mark all matched transactions as confirmed and credit the matched customers account with the transaction?',
                            theme: 'primary',
                        },
                        () => confirmAllMatched()
                    )
                },
            ]}
        />

        <ListView {...{
            transactions: liveSearch(transactions),
            hasSearchConditions,
            isEmpty,
            actioningTransaction,
            actionTransaction,
            matchCustomer,
            ignoreTransaction,
            resetTransaction,
            convertTransactionForCustomer,
        }} />

        <CustomerPicker title={null}
            isOpen={!!matchingTransaction}
            prompt={pickerPrompt}
            setIsOpen={() => setMatchingTransaction(false)}
            onPicked={async (customerId) => {
                await convertTransactionForCustomer(matchingTransaction, customerId)
                setMatchingTransaction(false);
                setPickerPrompt(false);
            }}
        />
    </>
}



export default Transactions;
